import { render } from "./device-show.vue?vue&type=template&id=79c8eafc&scoped=true"
import script from "./device-show.vue?vue&type=script&lang=js"
export * from "./device-show.vue?vue&type=script&lang=js"

import "./device-show.vue?vue&type=style&index=0&id=79c8eafc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c8eafc"]])

export default __exports__